import script from "./PayeeUpsert.vue?vue&type=script&lang=ts&setup=true"
export * from "./PayeeUpsert.vue?vue&type=script&lang=ts&setup=true"

import "./PayeeUpsert.vue?vue&type=style&index=0&id=91ee0012&lang=scss"

const __exports__ = script;

export default __exports__